import {
  GlobalActionTypes,
  SET_ORDER_VALID,
  SET_HAS_FORM_CHANGED,
  SET_HAS_CONTENT_LOADED,
  SET_CURRENT_DIALOG,
  SET_LANGUAGE,
  SET_PROMPT_LOGIN,
  SET_PAGE_TITLE,
  Dialog,
} from 'types/GlobalTypes';

export function setOrderValid(status: boolean): GlobalActionTypes {
  return {
    type: SET_ORDER_VALID,
    payload: status,
  };
}

export function setHasFormChanged(status: boolean): GlobalActionTypes {
  return {
    type: SET_HAS_FORM_CHANGED,
    payload: status,
  };
}

export function setHasContentLoaded(status: boolean): GlobalActionTypes {
  return {
    type: SET_HAS_CONTENT_LOADED,
    payload: status,
  };
}

export function setCurrentDialog(dialog: Dialog | undefined): GlobalActionTypes {
  return {
    type: SET_CURRENT_DIALOG,
    payload: dialog,
  };
}

export function setLanguage(language: string): GlobalActionTypes {
  return {
    type: SET_LANGUAGE,
    payload: language,
  };
}

export function setPromptLogin(status: boolean): GlobalActionTypes {
  return {
    type: SET_PROMPT_LOGIN,
    payload: status,
  };
}

export function setPageTitle(title: string): GlobalActionTypes {
  return {
    type: SET_PAGE_TITLE,
    payload: title,
  };
}
